import { api, type Api } from "@api/bot-base-api-request";
import { useQuery } from "@tanstack/react-query";
import { TokenTradedResponse } from "./types";

const BOT_GET_TOKEN_TRADED_QUERY_KEY = "bot-get-token-traded";

type BotGetTokenTradedParams = {
  appPubKey?: string;
  walletAddress?: string;
  chainId?: number;
};

const fetchBotTokenTraded = async (
  api: Api,
  params: BotGetTokenTradedParams,
): Promise<TokenTradedResponse> =>
  api.get("tokenTraded", { searchParams: params }).json();

const useBotTokenTraded = (params: BotGetTokenTradedParams) => {
  const shouldFetch =
    !!params.appPubKey && !!params.walletAddress && !!params.chainId;
  return useQuery({
    queryKey: [BOT_GET_TOKEN_TRADED_QUERY_KEY, params],
    queryFn: async () => fetchBotTokenTraded(api, params),
    enabled: shouldFetch,
  });
};

export {
  useBotTokenTraded,
  fetchBotTokenTraded,
  BOT_GET_TOKEN_TRADED_QUERY_KEY,
};
